import { c as _c } from "react/compiler-runtime";
import { CurrencyDollarIcon } from '@systemeio/icons';
import { CurrencyEnum, PricePlanType } from '@systemeio/types';
import { usePricePlansApi } from 'modules/digital-product/price-plans/hooks/use-price-plans-api';
import { useUserPricePlans } from 'modules/digital-product/price-plans/hooks/use-user-price-plans';
import { PricePlanEditInterface } from 'modules/digital-product/price-plans/types/price-plan-interface';
import { IconTile } from 'shared/components/icon-tile';
import React, { useEffect, useState } from 'react';
import { Button, FormInput, Hint, Modal, toast } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: PricePlanEditInterface = {
  name: '',
  innerName: '',
  statementDescriptor: ''
};
interface EditPricePlanModalProps {
  currency: CurrencyEnum;
  onClose: () => void;
  /** Called with the updated plan so the product draft can replace its copy. */
  onEdited: (pricePlan: PricePlanType) => void;
  opened: boolean;
  pricePlan?: PricePlanType;
}
export function EditPricePlanModal(t0) {
  const $ = _c(80);
  const {
    currency,
    onClose,
    onEdited,
    opened,
    pricePlan
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    updatePricePlan
  } = usePricePlansApi();
  const {
    mutateUserPricePlans
  } = useUserPricePlans(currency);
  const [tempState, setTempState] = useState(defaultValues);
  const [errors, setErrors] = useState(defaultValues);
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  let t2;
  if ($[0] !== opened || $[1] !== pricePlan) {
    t1 = () => {
      if (!opened || !pricePlan) {
        return;
      }
      setTempState({
        name: pricePlan.name,
        innerName: pricePlan.innerName,
        statementDescriptor: pricePlan.statementDescriptor
      });
      setErrors(defaultValues);
    };
    t2 = [opened, pricePlan];
    $[0] = opened;
    $[1] = pricePlan;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const isReady = !!tempState.name && !!tempState.innerName && !!tempState.statementDescriptor;
  let t3;
  if ($[4] !== isReady || $[5] !== mutateUserPricePlans || $[6] !== onClose || $[7] !== onEdited || $[8] !== pricePlan || $[9] !== t || $[10] !== tempState || $[11] !== updatePricePlan) {
    t3 = async event => {
      event.preventDefault();
      if (!pricePlan || !isReady) {
        return;
      }
      setIsFetching(true);
      await fetchWithErrors(async () => {
        const updated = await updatePricePlan(pricePlan.id, tempState);
        await mutateUserPricePlans(data => data && data.map(el => el.id === updated.id ? updated : el), false);
        onEdited(updated);
        toast.success(t("global.changes_saved"));
        onClose();
      }, setErrors);
      setIsFetching(false);
    };
    $[4] = isReady;
    $[5] = mutateUserPricePlans;
    $[6] = onClose;
    $[7] = onEdited;
    $[8] = pricePlan;
    $[9] = t;
    $[10] = tempState;
    $[11] = updatePricePlan;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const handleSave = t3;
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconTile size="m" tone="gray"><CurrencyDollarIcon /></IconTile>;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t) {
    t5 = t("dashboard.digital_product.price_plans.header.edit");
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <span>{t5}</span>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t) {
    t7 = t("dashboard.digital_product.price_plans.header.new-description");
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <span className="text-text-tertiary text-sm font-normal">{t7}</span>;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t8) {
    t9 = <div className="flex items-center gap-4">{t4}<div className="flex flex-col">{t6}{t8}</div></div>;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== handleSave) {
    t10 = <form onSubmit={handleSave} />;
    $[25] = handleSave;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t) {
    t11 = t("global.cancel");
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== isFetching || $[30] !== onClose || $[31] !== t11) {
    t12 = <Button type="button" className="tablet:flex-none flex-1" disabled={isFetching} onClick={onClose} variant="secondary" size="md">{t11}</Button>;
    $[29] = isFetching;
    $[30] = onClose;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  const t13 = !isReady;
  let t14;
  if ($[33] !== t) {
    t14 = t("global.save");
    $[33] = t;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== isFetching || $[36] !== t13 || $[37] !== t14) {
    t15 = <Button disabled={t13} isLoading={isFetching} className="tablet:flex-none flex-1" type="submit" variant="primary" size="md">{t14}</Button>;
    $[35] = isFetching;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t12 || $[40] !== t15) {
    t16 = <>{t12}{t15}</>;
    $[39] = t12;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t) {
    t17 = t("dashboard.funnel.configuration.common.price_plan.name_label");
    $[42] = t;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = e => setTempState(prev => ({
      ...prev,
      name: e.target.value
    }));
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== errors.name || $[46] !== t17 || $[47] !== tempState.name) {
    t19 = <FormInput required={true} label={t17} value={tempState.name} onChange={t18} maxLength={256} error={errors.name} />;
    $[45] = errors.name;
    $[46] = t17;
    $[47] = tempState.name;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t) {
    t20 = t("dashboard.funnel.configuration.common.price_plan.inner_name_label");
    $[49] = t;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = e_0 => setTempState(prev_0 => ({
      ...prev_0,
      innerName: e_0.target.value
    }));
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== errors.innerName || $[53] !== t20 || $[54] !== tempState.innerName) {
    t22 = <FormInput required={true} label={t20} value={tempState.innerName} onChange={t21} maxLength={256} error={errors.innerName} />;
    $[52] = errors.innerName;
    $[53] = t20;
    $[54] = tempState.innerName;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t) {
    t23 = t("dashboard.funnel.configuration.common.price_plan.statement_descriptor_popover");
    $[56] = t;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t) {
    t24 = t("dashboard.funnel.configuration.common.price_plan.statement_descriptor");
    $[58] = t;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== t23 || $[61] !== t24) {
    t25 = <Hint label={t23}>{t24}</Hint>;
    $[60] = t23;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = e_1 => setTempState(prev_1 => ({
      ...prev_1,
      statementDescriptor: e_1.target.value
    }));
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  let t27;
  if ($[64] !== errors.statementDescriptor || $[65] !== t25 || $[66] !== tempState.statementDescriptor) {
    t27 = <FormInput required={true} label={t25} value={tempState.statementDescriptor} onChange={t26} maxLength={22} error={errors.statementDescriptor} />;
    $[64] = errors.statementDescriptor;
    $[65] = t25;
    $[66] = tempState.statementDescriptor;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== t19 || $[69] !== t22 || $[70] !== t27) {
    t28 = <div className="flex flex-col gap-4">{t19}{t22}{t27}</div>;
    $[68] = t19;
    $[69] = t22;
    $[70] = t27;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  let t29;
  if ($[72] !== isFetching || $[73] !== onClose || $[74] !== opened || $[75] !== t10 || $[76] !== t16 || $[77] !== t28 || $[78] !== t9) {
    t29 = <Modal opened={opened} onClose={onClose} isFetching={isFetching} title={t9} render={t10} footer={t16}>{t28}</Modal>;
    $[72] = isFetching;
    $[73] = onClose;
    $[74] = opened;
    $[75] = t10;
    $[76] = t16;
    $[77] = t28;
    $[78] = t9;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  return t29;
}